import React, {useState} from 'react';
import { Form, InputGroup, Button} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import ListGroup from 'react-bootstrap/ListGroup'; 
import {faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Rightbar from './Rightbar';
import {Link, useParams } from 'react-router-dom';


export default function YourProgramming(){ 
const params = useParams();
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}
return(
<>
<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
<div >
<Rightbar/>
</div>
</div>
<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar '>
<Button variant="outline-info" onClick={toggle}>
<FontAwesomeIcon icon={faAlignLeft} />
</Button>


<h1>View Booth</h1>
<p>You have not created any booths yet</p>
<br/> 
<Link to={`/createvirtualbooth/${params.id}`}><Button className='common-btn'>CREATE PROGRAMMING</Button></Link>

</div>
</div>
</div>
</div>
</div>
</section>  


</>
)
}
